import useGetNewspaperConfigInitialData from './useGetNewspaperConfigInitialData'
export default useGetNewspaperConfigInitialData
